import { DealershipList, SelectedUserLocation } from '../types/locations';
import {
  VTPDataLayerEvent,
  Event,
  DealerLocatorLocationSelectEventBody,
  DealerLocatorDealerSaveEventBody,
  DealerLocatorDealerSelectEventBody,
  DealerLocatorRadiusSliderEventBody,
} from '../types/analytics';
import { GeoJSONProperties } from '../hooks/useDealershipList';
import { PlaceResultType } from '../types/placeResultLocation';
import { MARKET } from '../constants/market';

// extend window interface so we can add a global
declare global {
  interface Window {
    ixisDataLayer: VTPDataLayerEvent[];
  }
}
window.ixisDataLayer = window.ixisDataLayer || [];

const FEATURE_APP_ID = __FEATURE_APP_NAME__;
const FEATURE_APP_BASE_URL =
  'https://fa-new-vlp-location-search.cdn.dev.collab.apps.one.audi/next/fh/app.js';

export const locationSelectAnalyticsEvent = async (
  newLocation: SelectedUserLocation,
  isGeoLocation?: boolean,
) => {
  const event: Event<DealerLocatorLocationSelectEventBody> = {
    vtp: {
      type: 'dealer_locator_location_select',
      payload: {
        locationData: {
          // ASK Place Name? OR Formatted_address?
          // WHY 'geolocate'
          locationName: isGeoLocation ? 'geolocate' : newLocation.feature.name || '',
          locationCity: newLocation.feature.city || '',
          locationState: newLocation.feature.region || '',
          locationPostalCode: newLocation.feature.postalCode || '',
        },
        element: {
          section: 'Dealer Locator',
          featureAppID: FEATURE_APP_ID, // feature app id of dealer locator
          featureAppBaseUrl: FEATURE_APP_BASE_URL, // feature app base url of dealer locator
        },
      },
    },
  };
  window.ixisDataLayer.push(event);
};

export const dealerSaveAnalyticsEvent = (
  dealershipList: DealershipList,
  radius: string | null,
  searchMode: string,
  dealersInRadius: number,
  userLocation?: SelectedUserLocation,
) => {
  const event: Event<DealerLocatorDealerSaveEventBody> = {
    vtp: {
      type: 'dealer_locator_dealer_save',
      payload: {
        dealerList: dealershipList.map((dealership) => ({
          dealerName: dealership.name,
          dealerCode: dealership.kvpsSyncId,
        })),
        element: {
          section: 'Dealer Locator',
          featureAppID: FEATURE_APP_ID, // feature app id of dealer locator
          featureAppBaseUrl: FEATURE_APP_BASE_URL, // feature app base url of dealer locator
        },
        locationData: {
          locationName: userLocation?.feature.formattedAddress || '',
          locationCity: userLocation?.feature?.city || '',
          locationState: userLocation?.feature?.region || '',
          locationPostalCode: userLocation?.feature?.postalCode || '',
        },
        locator: {
          mode: searchMode,
          dealersInRadius,
          radius,
        },
      },
    },
  };
  window.ixisDataLayer.push(event);
};

export const dealerSelectAnalyticsEvent = (
  dealerShip: GeoJSONProperties,
  radius: string | null,
  dealersInRadius: number,
  select: boolean,
  userLocation?: PlaceResultType,
  distance?: string,
) => {
  const event: Event<DealerLocatorDealerSelectEventBody> = {
    vtp: {
      type: select ? 'dealer_locator_dealer_select' : 'dealer_locator_dealer_deselect',
      payload: {
        dealership: {
          distance: distance || '',
          name: dealerShip?.name || '',
          storeFrontCity: dealerShip?.address?.city || '',
          storeFrontState: dealerShip?.address?.region || '',
        },
        element: {
          section: 'Dealer Locator',
          featureAppID: FEATURE_APP_ID, // feature app id of dealer locator
          featureAppBaseUrl: FEATURE_APP_BASE_URL, // feature app base url of dealer locator
        },
        locationData: {
          locationName: userLocation?.name || '',
          locationCity: userLocation?.city || '',
          locationState: userLocation?.region || '',
          locationPostalCode: userLocation?.postalCode || '',
        },
        locator: {
          mode: 'BY_DEALER',
          dealersInRadius,
          radius,
        },
      },
    },
  };
  window.ixisDataLayer.push(event);
};

export const radiusSliderEvent = (
  radius: string | null,
  dealersInRadius: number,
  userLocation?: PlaceResultType,
) => {
  const event: Event<DealerLocatorRadiusSliderEventBody> = {
    vtp: {
      type: 'dealer_locator_radius_slider',
      payload: {
        input: {
          inputTitle: 'Your Radius',
          inputValue: `${radius}${MARKET === 'CAN' ? 'km' : 'mi'}`,
        },
        element: {
          section: 'Dealer Locator',
          featureAppID: FEATURE_APP_ID, // feature app id of dealer locator
          featureAppBaseUrl: FEATURE_APP_BASE_URL, // feature app base url of dealer locator
        },
        locationData: {
          locationName: userLocation?.name || '',
          locationCity: userLocation?.city || '',
          locationState: userLocation?.region || '',
          locationPostalCode: userLocation?.postalCode || '',
        },
        locator: {
          mode: 'BY_RADIUS',
          dealersInRadius,
          radius,
        },
      },
    },
  };
  window.ixisDataLayer.push(event);
};
